export default __webpack_public_path__ + "static/media/fillshare-weekday.9e772bf1.png";